export default __webpack_public_path__ + "static/media/loading.ce8efc46.svg";